module.exports = __webpack_public_path__ + "img/step06_b_stand_basic_left_bottom_cross_fix_screws.0fc360e9.png";